<template>
  <div class="register-wrap" id="scrollDiv" ref="scrollDiv">
    <div class="section-1">
        <img src="../../../src/assets/images/spring/signHeader.png">
    </div>
    <div class="section-2">
      <img src="../../assets/images/winter/award.png" />
    </div>
    <div class="section-3">
      <div class="title">
        <img src="../../assets/images/winter/title.png" />
      </div>
      <ul class="register-box-ul">
        <li>
          <div class="form-item">
            <i class="people-icon"></i>
            <input v-model.trim="userName" type="text" placeholder="请输入学生姓名" />
            <!-- <p v-if="showErrorTips1 != ''" class="error-tips">{{ showErrorTips1 }}</p> -->
          </div>
        </li>
        <li>
          <div class="form-item">
            <i class="account-icon"></i>
            <input v-model.number="userPhone" maxlength="11" type="text" placeholder="请输入家长手机"
              oninput="value=value.replace(/[^\d]/g,'')" />
            <!-- <p v-if="showErrorTips2 != ''" class="error-tips">{{ showErrorTips2 }}</p> -->
          </div>
        </li>
      </ul>
      <div class="register-btn" :class="isDisabled ? 'disabled' : ''" @click="register">
        报名参与
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import { addActivityCustom } from "../../api/winterGame";
import { debounce } from "@/util/util";
export default {
  data() {
    return {
      campusId: "",
      followUserId: "",
      sourceName: "",
      userName: "",
      userPhone: "",
      isDisabled: false,
    };
  },
  watch: {
    userName(newVal, oldVal) {
      if (newVal.trim() == "") {
        this.showErrorTips1 = "请输入学生姓名";
      } else {
        this.showErrorTips1 = "";
      }
    },
    userPhone(newVal, oldVal) {
      if (newVal == "") {
        this.showErrorTips2 = "请输入家长手机";
      } else {
        let reg = /(1[3-9]\d{9}$)/;
        if (!reg.test(newVal)) {
          this.showErrorTips2 = "请输入正确格式的手机号码";
        } else {
          this.showErrorTips2 = "";
        }
      }
    },
  },
    created() {
        document.title = this.$route.meta.title || '松鼠杯'
    },
    mounted() {
    let { c, f, s } = this.$route.query;
    this.campusId = c;
    this.followUserId = f;
    this.sourceName = s;
  },
  methods: {
    handleScrollTop() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({ top: 0, behavior: "smooth" });
      });
    },
    register: debounce(
      async function () {
        const scrollDiv = this.$refs.scrollDiv; //vue的写法 mypklogList是表现中 ref=“mypklogList”
        const phone = /^1[3456789]\d{9}$/;
        if (scrollDiv.offsetTop < 200) {
          scrollDiv.scrollIntoView({
            block: "end",
            behavior: "smooth",
          });
        }
        if (!this.userName) {
          return;
        }
        if (!this.userPhone) {
          return;
        }
        if (!(/^1[3456789]\d{9}$/.test(this.userPhone))) {
          Toast("手机号码不正确");
          return;
        }
        let params = {
          param: {
            campusId: this.campusId,
            followUserId: this.followUserId,
            sourceName: this.sourceName,
            studentMobile: this.userPhone,
            studentName: this.userName,
          },
        };
        addActivityCustom(params).then((res) => {
          if (res.code == 0) {
            this.isDisabled = true;
            // gio("track", "OnClickSignUp", { successfulRegistration: "signUp" });
            Dialog.alert({
              title: "报名成功",
              message: "请耐心等待工作人员与您联系",
              confirmButtonText: "我知道了",
              confirmButtonColor: "#58ABF6",
            }).then(() => {
              scrollDiv.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            });
          } else {
            Toast(res.message);
          }
        });
      },
      1000,
      true
    ),
  },
};
</script>

<style lang="less" scoped>
.register-wrap {
  // background: linear-gradient(180deg, #00236D 0%, #001D46 100%);

  background: #162487;
  padding-bottom: 200px;

  .section-1 {
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }

  .section-2 {
    text-align: center;
    img {
      width: 90%;

      vertical-align: bottom;
    }
  }

  .section-3 {
    .title {
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        width: 342px;
        height: 80px;
      }
    }

    .register-box-ul {
      background: #A4C2FF;
      border-radius: 16px;
      margin: 0 32px 0;
      padding: 60px 32px;

      li {
        margin-bottom: 48px;

        .form-item {
          position: relative;

          input {
            width: 100%;
            height: 96px;
            background: #f6f9fd;
            border-radius: 48px;
            border: none;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-indent: 96px;
          }

          .people-icon {
            position: absolute;
            width: 32px;
            height: 32px;
            top: 50%;
            left: 50px;
            margin-top: -16px;
            background: url("../../assets/images/winter/peopleIcon.png") no-repeat center;
            background-size: 100%;
          }

          .account-icon {
            position: absolute;
            width: 32px;
            height: 32px;
            top: 50%;
            left: 50px;
            margin-top: -16px;
            background: url("../../assets/images/winter/accountIcon.png") no-repeat center;
            background-size: 100%;
          }

          .error-tips {
            position: absolute;
            left: 30px;
            bottom: -40px;
            color: #f56c6c;
            font-size: 12px;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .register-btn {
      width: 600px;
      height: 96px;
      background: #58abf6;
      border-radius: 57px;
      margin: 48px auto 0;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      bottom: 0;
      left: 50%;
      bottom: 48px;
      transform: translate(-50%, 0);

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }

      &.disabled {
        background-color: #c8c9cc;
        color: #fff;
        pointer-events: none;
      }
    }
  }
}
</style>
